import { I18n } from 'react-redux-i18n';

export const getSendNexProgressMessage = (stage) => {
    switch (stage) {
        case 'signing':
            return I18n.t('wallet.sendNex.progress.signing');
        case 'broadcasting':
            return I18n.t('wallet.sendNex.progress.broadcasting');
        case 'iniciating':
        default:
            return I18n.t('wallet.sendNex.progress.iniciating');
    }
};
